import { render, staticRenderFns } from "./ConfiguratorCanvas.vue?vue&type=template&id=61216bb4&scoped=true&"
import script from "./ConfiguratorCanvas.vue?vue&type=script&lang=ts&"
export * from "./ConfiguratorCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./ConfiguratorCanvas.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ConfiguratorCanvas.vue?vue&type=style&index=1&id=61216bb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61216bb4",
  null
  
)

export default component.exports